export default __webpack_public_path__ + "static/media/orange-juice-menu.f1b03067.png";